import React, { useEffect, Fragment } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import './dropdown.css';
import { makeApiCall } from '../../redux/actions/common/common-action';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import COLORS from '../../common/styles/color-pallete';
import { DROPDOWN_ICON } from '@Images';

type option = {
  value: string;
  text: string;
};
interface ISimpleSelect {
  label: string;
  value?: string;
  bindToThisObject?: string;
  options: option[];
  placeholder: string;
  optional?: boolean;
  url?: string;
  dependedOnObject?: boolean;
  preselect_if_one_item?: boolean;
  preselect_and_disable_if_one_item?: boolean;
  input: {
    IconComponent: React.ElementType;
    onChange: any;
    value: string;
  };
  meta: {
    error: string | boolean;
    touched: boolean;
  };
  boxSize: string;
  changeOptionType?: boolean;
  selectType?: boolean;
  noStyle?: boolean;
  onDropdownClose?: any;
  disabled?: boolean;
  onClick?: any;
  onDropdownChange?: ({ value }: { value: string }) => void;
}
export const useStyles: any = makeStyles((theme) => {
  return {
    '@global': {
      '.MuiAutocomplete-option': {
        padding: '15px',
        '&:hover': {
          borderRadius: '2px',
          background: 'rgba(72, 249, 254, 0.4)'
        }
      },
      '.MuiAutocomplete-inputRoot[class*=`MuiOutlinedInput-root`].MuiAutocomplete-endAdornment': {
        right: '7px'
      },
      '.MuiAutocomplete-inputRoot .MuiAutocomplete-input ': {
        width: '0',
        minWidth: '50px',
        paddingLeft: '0px'
      },
      '.MuiFormLabel-root': {
        fontSize: '14px;',
        fontFamily: 'hellix-regular'
      },
      '.MuiFormHelperText-root.Mui-error': {
        color: 'red',
        fontSize: '10px',
        lineHeight: 'normal'
      },
      '.MuiSelect-iconOutlined': {
        right: '7px',
        top: '23px'
      },
      '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #000 !important'
      },
      '.MuiFormLabel-root.Mui-focused': {
        color: '#000 !important'
      },
      '.MuiAutocomplete-listbox': {
        padding: '0px'
      }
    },
    inputRoot1: {
      maxWidth: '325px',
      color: '#000000',
      height: '50px'
    },
    inputRoot2: {
      maxWidth: '90px',
      color: '#000000',
      height: '50px',
      fontSize: '15px'
    },
    option1: {
      maxHeight: '300px',
      borderRadius: '3px',
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: COLORS.white,
      maxWidth: '309px'
    },
    menuItemRoot: {
      padding: '16px 30px',
      color: '#000000',
      fontFamily: 'hellix-regular',
      fontSize: '16px'
    },
    formControl: {
      margin: theme.spacing(1),
      fullWidthTop: true,
      display: 'flex',
      wrap: 'nowrap'
    },
    selectEmpty: {
      margin: theme.spacing(2)
    },
    selectMenu: {
      maxHeight: '300px',
      borderRadius: '3px',
      boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: COLORS.white,
      maxWidth: '325px',
      width: '325px'
    },
    commonSelect: {
      color: '#000000',
      height: '50px',
      padding: '0px',
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    smallSelect: {
      color: '#000000',
      height: '50px',
      maxWidth: '80px'
    }
  };
});
const dropdownIconStyle = {
  width: '20px',
  marginRight: '2px',
  marginTop: '8px'
};
const dropdownIconNullStyle = { marginRight: '5px', marginTop: '5px' };
const IconComponent = (props: any) => {
  return (
    <img
      src={DROPDOWN_ICON}
      height="12px"
      style={{ marginRight: '5px' }}
      {...props}
      alt="dropdown arrow"
    />
  );
};

const BoxDropdown: React.FC<ISimpleSelect> = (props) => {
  const { options = [] } = props;
  const classes = useStyles();
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  const [option, setOptions] = React.useState<any>([]);
  const [toRenderVal, setToRenderVal] = React.useState<string>('');
  const [autoCompleteInput, setAutoCompleteValInput] = React.useState<any>('');
  const [placeholder, setPlaceholder] = React.useState<string>('');
  const [openDropdown, setOpenDropdown] = React.useState<boolean>(false);

  //save cpy of toRenderVal in placeholder
  useEffect(() => {
    if (toRenderVal) {
      setPlaceholder(toRenderVal);
    }
  }, [toRenderVal]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    // eslint-disable-line react-hooks/exhaustive-deps
    if (!props.bindToThisObject && !autoCompleteInput) {
      setAutoCompleteValInput('');
    } else {
      setAutoCompleteValInput(autoCompleteInput);
    }
  }, [props.bindToThisObject, autoCompleteInput]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setAutoCompleteValInput(getInputValues());
  }, [props.bindToThisObject]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    setOptions(props.options);
  }, [options.length]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    async function handleAsync() {
      if (props.url) {
        if (props.dependedOnObject === false) return;
        await httpRequest(props.url, props.placeholder);
      }
    }
    handleAsync();
  }, [props.url]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    async function mapFieldToValue() {
      if (props.input.value) {
        if (props.options && props.options.length > 0) {
          const inputValue =
            props.options.length > 0 &&
            props.options.filter((obj) => obj.value === props.input.value)[0]?.text;
          setAutoCompleteValInput(inputValue);
        } else if (props.url) {
          try {
            const {
              data: { data }
            } = await makeApiCall({
              method: 'get',
              url: props.url,
              withCredentials: true
            });
            const inputValue = data.filter(
              (obj: { value: string }) => obj.value === props.input.value
            )[0].text;
            setAutoCompleteValInput(inputValue);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error('error in boxDropdown', e, props);
          }
        }
      }
    }
    mapFieldToValue();
  }, [props.input.value]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    inputLabel.current && setLabelWidth(inputLabel.current.offsetWidth);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const httpRequest = async (url: string, placeholder: string) => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: url,
        withCredentials: true
      });
      if (response && response.data && response.data.success) {
        const res = response.data.data.map((item: any) => {
          return { ...item, key: item.key };
        });
        if (res[0].phone_number_validation) {
          // eslint-disable-next-line array-callback-return
          const shortenMobileCode = res.map((data: any) => {
            if (data.text) {
              const text = `+${parseInt(data.text.replace(/[^0-9]/g, ''), 10).toString()}`;
              return { ...data, text };
            }
          });
          return setOptions(shortenMobileCode);
        } else {
          return setOptions(res);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  function getInputValues() {
    let value;
    if (props.url && props.bindToThisObject) {
      const selectedObj =
        option &&
        option.length > 0 &&
        option.filter((obj: any) => props.bindToThisObject === obj.key)[0];
      value = selectedObj ? selectedObj.text : props.bindToThisObject;
      return value;
    } else {
      return props.input.value;
    }
  }

  const handleClickAway = () => {
    setOpenDropdown(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <FormControl
        variant="outlined"
        className={classes.formControl}
        error={props.meta.touched && props.meta.error ? true : false}
      >
        {props.selectType === true ? (
          <Fragment>
            <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
              {props.label || props.placeholder}
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              labelWidth={labelWidth}
              {...props.input}
              className={props.boxSize === 'small' ? classes.smallSelect : classes.commonSelect}
              IconComponent={props.input.IconComponent ? props.input.IconComponent : IconComponent}
              MenuProps={{
                classes: { paper: classes.selectMenu },
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left'
                }
              }}
            >
              {option !== undefined
                ? option.map((option: any, index: any) => (
                    <MenuItem
                      key={index}
                      classes={{ root: classes.menuItemRoot }}
                      className="menu-list"
                      value={option.key}
                    >
                      {option.text}
                    </MenuItem>
                  ))
                : []}
            </Select>
            {props.meta.touched && props.meta.error && (
              <FormHelperText>{props.meta.error}</FormHelperText>
            )}
          </Fragment>
        ) : (
          <>
            <Autocomplete
              key={toRenderVal}
              closeIcon={''}
              forcePopupIcon={true}
              id="demo-simple-select-outlined"
              onClick={() => {
                setToRenderVal('');
                setAutoCompleteValInput('');
                setOpenDropdown(true);
              }}
              options={option !== undefined ? option : []}
              getOptionLabel={({ text = '', value = '' }: any) => {
                return text ? text : value;
              }}
              classes={{
                inputRoot: props.boxSize === 'small' ? classes.inputRoot2 : classes.inputRoot1,
                option: classes.hasClearIcon
              }}
              popupIcon={
                <img
                  onClick={() => {
                    setToRenderVal('');
                    setAutoCompleteValInput('');
                    setOpenDropdown(true);
                  }}
                  src={DROPDOWN_ICON}
                  style={props.noStyle ? dropdownIconNullStyle : dropdownIconStyle}
                  alt="dropdown arrow"
                />
              }
              disabled={props.disabled}
              open={openDropdown}
              onClose={(e: any, r: any) => {
                if (r) {
                  if (placeholder) {
                    setAutoCompleteValInput(placeholder);
                    setToRenderVal(placeholder);
                  }
                }
                if (r === 'select-option') {
                  const selectedObj =
                    option.length > 0
                      ? option.filter(
                          (obj: any) =>
                            obj.text === e.target.innerText || obj.value === e.target.innerText
                        )[0]
                      : null;
                  props.onDropdownClose && props.onDropdownClose(selectedObj);
                }
              }}
              inputValue={autoCompleteInput?.toString()}
              renderOption={(option: any) => {
                return option.content ? option.content : option.text;
              }}
              onChange={(e: any, text: any) => {
                setOpenDropdown(false);
                if (text && text.value && props.onDropdownChange) props.onDropdownChange(text);
                text && text.value && props.input.onChange(text.value);
                text && text.value && setToRenderVal(text.text);
                text && text.text && setAutoCompleteValInput(text.text);
              }}
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  value={option !== undefined ? option.key : []}
                  label={props.placeholder}
                  variant="outlined"
                  // it clears all vlaue its dangerous
                  onClick={() => {
                    setAutoCompleteValInput('');
                    setOpenDropdown((state) => !state);
                  }}
                  error={props.meta.touched && props.meta.error ? true : false}
                  onChange={(e) => {
                    setAutoCompleteValInput(e.target.value);
                  }}
                />
              )}
            />
            {props.meta.touched && props.meta.error && (
              <FormHelperText>{props.meta.error}</FormHelperText>
            )}
          </>
        )}
      </FormControl>
    </ClickAwayListener>
  );
};
export { BoxDropdown };
